import { render, staticRenderFns } from "./AnimationBoxCatalog.vue?vue&type=template&id=92f5c1e4&scoped=true"
import script from "./AnimationBoxCatalog.vue?vue&type=script&setup=true&lang=js"
export * from "./AnimationBoxCatalog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AnimationBoxCatalog.vue?vue&type=style&index=0&id=92f5c1e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92f5c1e4",
  null
  
)

export default component.exports